import { CONSENT_TYPES } from '../enums';
import { NON_REVOCABLE_CONSENT_TYPES, ORGANIZATION_ACCOUNT_REQUIRED_CONSENT_TYPES, REQUIRED_CONSENT_TYPES, RETIRED_CONSENT_TYPES, } from '../consent-policy';
import { LEGAL_DOCUMENTS, OPEN_CONSENT_TYPES } from './registry';
import { LEGAL_DOCUMENT_SLUGS } from './types';
/**
 * Rıza türünün metni. TÜRETİLİR: önce türe DOĞRUDAN bağlı belge aranır
 * (`LEGAL_DOCUMENTS[*].consentType`), bulunamazsa tür açık rıza metninin
 * kapsamındadır. İkinci bir eşleme tablosu tutulsaydı kayıtla ayrışırdı.
 */
export function consentDocumentOf(type) {
    const direct = LEGAL_DOCUMENT_SLUGS.find((slug) => LEGAL_DOCUMENTS[slug].consentType === type);
    if (direct !== undefined)
        return direct;
    // Emekli tür (defterdeki eski satırlar) verildiği metne, açık rıza metnine bağlı kalır.
    if (OPEN_CONSENT_TYPES.includes(type) || RETIRED_CONSENT_TYPES.includes(type))
        return 'acik-riza';
    /*
     * Buraya düşmek, `CONSENT_TYPES`e metinsiz bir tür eklendiği anlamına gelir.
     * `consent-groups.guard.spec` bunu derleme değil TEST zamanında yakalar;
     * çalışma zamanında sessizce yanlış metne bağlamaktansa patlaması yeğdir.
     */
    throw new Error(`consent type has no legal document: ${type}`);
}
/**
 * Aydınlatma metinleri "okundu" satırıdır. Liste hâlinde durur ki yeni bir
 * bilgilendirme yükümlülüğü eklenirse kapı iki ayağı da ölçebilsin (hangileri
 * okundu satırı, hangileri DEĞİL). Kurum hesabı aydınlatma metni (V11) kurum
 * hesabının KVKK aydınlatmasıdır, aynı sınıftadır.
 */
const ACKNOWLEDGE_ONLY = [
    'kvkk_clarification',
    'organization_account_notice',
];
function rowOf(type) {
    return {
        type,
        presentation: ACKNOWLEDGE_ONLY.includes(type) ? 'acknowledge' : 'accept',
        document: consentDocumentOf(type),
    };
}
/**
 * ZORUNLU GRUP — "devam etmek için gerekli". Kayıt isteği bunlarsız
 * reddedilir (`consents.service`), bu yüzden kaynak `REQUIRED_CONSENT_TYPES`tir.
 */
export const REQUIRED_CONSENT_ROWS = REQUIRED_CONSENT_TYPES.map(rowOf);
/**
 * İSTEĞE BAĞLI GRUP — "reddetseniz de hesabınız açılır". Hepsi varsayılan
 * KAPALI ve her an geri alınabilir.
 *
 * SIRA TASARIMDANDIR (`_b-MobilKayit.html` · `_b-MobilRiza.html`): pazarlama
 * → analitik (görünürlük satırı 09.10.2026'da emekliye ayrıldı).
 * `OPEN_CONSENT_TYPES` bir KÜME'dir (kapsam), sıra
 * değil; sunum sırası burada durur ama ÜYELİK oradan gelir — kapı ikisinin
 * aynı kümeyi verdiğini asserter.
 */
const OPTIONAL_ORDER = ['marketing_email', 'analytics'];
export const OPTIONAL_CONSENT_ROWS = OPTIONAL_ORDER.map(rowOf);
/**
 * KİŞİSEL HESABIN iki grubu birden — "her tür tam olarak bir grupta"
 * ölçümünün girdisi. Kurum hesabına özgü metin bu kümede YOKTUR.
 */
export const ALL_CONSENT_ROWS = [
    ...REQUIRED_CONSENT_ROWS,
    ...OPTIONAL_CONSENT_ROWS,
];
/**
 * KURUM HESABININ TEK GRUBU (kullanıcı kararı 02.10.2026 · V11): kullanım
 * koşulları + kurum hesabı aydınlatma metni. İsteğe bağlı grup YOKTUR, çünkü
 * kurum hesabında görünürlük, pazarlama ve analitik işlemesi yoktur.
 */
export const ORGANIZATION_ACCOUNT_CONSENT_ROWS = ORGANIZATION_ACCOUNT_REQUIRED_CONSENT_TYPES.map(rowOf);
/**
 * EMEKLİ RIZANIN GERİ ÇEKME SATIRI (B-16 QA). Geri alma hakkı kısıtlanamaz:
 * defterde hâlâ VERİLMİŞ duran emekli tür, rıza merkezinde yalnız "Geri çek"
 * eylemiyle çizilir. Geri çekilmiş ya da hiç verilmemiş tür çizilmez ve
 * yeniden verme yolu yoktur (sunucu `consent.retired` ile reddeder). Web ve
 * mobil aynı listeyi buradan alır, "verilmiş mi" sorusunu kendi kaynağından
 * cevaplar (web defterin son satırı, mobil `current` ucu).
 */
export function withdrawableRetiredConsentRows(isGranted) {
    return RETIRED_CONSENT_TYPES.filter(isGranted).map(rowOf);
}
/**
 * Rıza merkezinde zorunlu grup KİLİTLİDİR: geri alınamaz, çünkü geri alınması
 * hizmetin kendisini imkânsız kılar (kullanıcının çıkışı hesap silmedir ve
 * ekranda oraya bağlanır). İsteğe bağlı grup anahtarlıdır.
 */
export function isRevocable(type) {
    return !NON_REVOCABLE_CONSENT_TYPES.includes(type);
}
/**
 * Herkese açık hukuki metnin adresi. Mobil, metni native çizmek yerine bu
 * adrese açar; adres web ile TEK yerden paylaşılır ki iki taraf ayrışmasın.
 */
export function legalDocumentPath(locale, slug) {
    return `/${locale}/legal/${slug}`;
}
/** Kapı girdisi: sözleşmedeki tür sayısı (bugün 7). Elle yazılmaz. */
export const CONSENT_TYPE_COUNT = CONSENT_TYPES.length;
//# sourceMappingURL=consent-groups.js.map